// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1T4vk","header":"ClearentDisclaimer_header__3uxE1","inner":"ClearentDisclaimer_inner__1b97r"};